// API клиент для лендинга
// API находится на sntea.online, лендинг на sntea.ru
const API_BASE = import.meta.env.VITE_API_URL || 'https://sntea.online';

interface Product {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
  imageUrl?: string | null;
  price: string;
  priceWholesaleLarge?: string | null;
  minQty: number;
  unit: string;
  categoryId?: string;
  ozonOfferId?: string | null;
}

interface Category {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
}

async function request<T>(path: string): Promise<T> {
  const url = `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`API error: ${res.status}`);
  }
  return res.json();
}

export const api = {
  async products(): Promise<Product[]> {
    return request<Product[]>('/api/products/catalog');
  },
  async categories(): Promise<Category[]> {
    return request<Category[]>('/api/categories/catalog');
  },
};

export type { Product, Category };
